var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33332 9.87566V6.1243C9.33332 4.0275 9.33332 2.9791 8.71645 2.71819C8.09958 2.45728 7.37352 3.19861 5.92153 4.68127C5.16958 5.44909 4.74055 5.61912 3.67068 5.61912C2.73503 5.61912 2.26721 5.61912 1.93115 5.8484C1.23355 6.32436 1.339 7.25466 1.339 7.99999C1.339 8.74532 1.23355 9.67559 1.93115 10.1516C2.26721 10.3809 2.73503 10.3809 3.67068 10.3809C4.74055 10.3809 5.16958 10.5509 5.92153 11.3187C7.37352 12.8014 8.09958 13.5427 8.71645 13.2818C9.33332 13.0209 9.33332 11.9725 9.33332 9.87566Z",
    stroke: "#141B34",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6C11.7502 6.54645 12 7.24227 12 8C12 8.75773 11.7502 9.45353 11.3333 10",
    stroke: "#141B34",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.66666C14.1672 5.57741 14.6666 6.73712 14.6666 7.99999C14.6666 9.26286 14.1672 10.4226 13.3333 11.3333",
    stroke: "#141B34",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.f1e059684ca069d6d9af83dc6e000b7d.svg";
export { ForwardRef as ReactComponent };